import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { formatDate } from '../../common/SharedFunctions';
import { BfiDataGrid, Column } from '../../common/SharedComponents';
import { GridSettingType } from '@apply/constants';
import { UsersApi } from '@apply/api';
import { applicationInsights } from '../../ApplicationInsights';
import { ActionType } from '../../borrowers/common/BorrowerConstants';
import { executePrincipalAction, onPrincipalActionsCellRender } from '../common/Functions';
import { BorrowerModals } from '../../borrowers/common/BorrowerComponents';
import { Tooltip } from 'devextreme-react/tooltip';

const PrincipalUsersTable = ({ gridStore, filter }) => {
    const searchState = useSelector((state) => state.searchState);
    const [dataStore, set_dataStore] = useState(gridStore?.store);

    const usersApi = new UsersApi.UsersApi(applicationInsights);

    const dataFunction = (criteria) => {
        if (!criteria) {
            return;
        }
        criteria.filter = filter;
        return usersApi.getPrincipalUsers(criteria);
    };

    useEffect(() => {
        if (gridStore) {
            gridStore.setOnLoad('id', dataFunction, searchState?.searchText?.principalUser);
            set_dataStore(gridStore.store);
        }
    }, [gridStore]);

    const dateCellRender = (date) => {
        if (date) {
            return <>{formatDate(date)}</>;
        }

        return;
    };

    const onIsLocRender = (e) => {
        return e.value ? 'Yes' : 'No';
    };

    const onCellDblClick = (e) => {
        if (e.rowType !== 'data' || e.column.type === 'detailExpand' || e.column.type === 'actions') {
            return;
        }
        var model = {
            actionId: ActionType.EditPrincipal,
            principalId: e.data.principalId,
        };
        executePrincipalAction(model, false);
    };

    const onHighlightCellRender = (e) => {
        if (!e.value) {
            return null;
        }
        const targetId = 'hrow' + e.data.id;
        return (
            <>
                <div
                    data-tip
                    data-for={targetId}
                >
                    <span
                        className='reddot'
                        style={{ position: 'unset' }}
                    ></span>
                </div>
                <Tooltip
                    target={`[data-for="${targetId}"]`}
                    showEvent='mouseenter'
                    hideEvent='mouseleave'
                    hideOnOutsideClick={false}
                >
                    {e.data.tooltip}
                </Tooltip>
            </>
        );
    };

    if (!dataStore) {
        return null;
    }

    return (
        <>
            <BfiDataGrid
                gridType={GridSettingType.PrincipalUsersTable}
                dataStore={dataStore}
                applicationInsights={applicationInsights}
                onCellDblClick={onCellDblClick}
            >
                <Column
                    dataField='highlight'
                    caption=''
                    width={20}
                    cellRender={onHighlightCellRender}
                    alignment='center'
                    allowReordering={false}
                    allowSorting={false}
                    allowResizing={false}
                />
                <Column
                    dataField='firstName'
                    caption='First'
                    dataType='string'
                    width={120}
                />
                <Column
                    dataField='lastName'
                    caption='Last'
                    dataType='string'
                    width={120}
                />
                <Column
                    dataField='email'
                    caption='Email'
                    dataType='string'
                />
                <Column
                    dataField='created'
                    caption='Created'
                    cellRender={(e) => dateCellRender(e.data.created)}
                    width={100}
                />
                <Column
                    dataField='lastActive'
                    caption='Last Active'
                    cellRender={(e) => dateCellRender(e.data.lastActive)}
                    width={90}
                />
                <Column
                    dataField='lastLoginIPAddress'
                    caption='Last Login IP'
                    dataType='string'
                    width={100}
                />
                <Column
                    dataField='lastPasswordRequested'
                    caption='Pwd Rqstd'
                    cellRender={(e) => dateCellRender(e.data.lastPasswordResetRequested)}
                    width={90}
                />
                <Column
                    dataField='lastPasswordResetSent'
                    caption='Pwd Rst Eml'
                    cellRender={(e) => dateCellRender(e.data.lastPasswordResetSent)}
                    width={90}
                />
                <Column
                    dataField='lastFailedLogin'
                    caption='Failed Login'
                    cellRender={(e) => dateCellRender(e.data.lastFailedLoginAttempt)}
                    width={90}
                />
                <Column
                    dataField='eSignDate'
                    caption='E-Sign Date'
                    cellRender={(e) => dateCellRender(e.data.eSignDate)}
                    width={90}
                />
                <Column
                    dataField='isLoc'
                    caption='Is LOC'
                    width={80}
                    cellRender={onIsLocRender}
                />
                <Column
                    dataField='submittedAppCount'
                    caption='Subm.'
                    width={80}
                />
                <Column
                    dataField='unSubmittedAppCount'
                    caption='UnSubm.'
                    width={80}
                />
                <Column
                    dataField='userResponsible'
                    caption='POC'
                    dataType='string'
                    width={110}
                />
                <Column
                    alignment='center'
                    cellRender={(e) => onPrincipalActionsCellRender(e, 'PrincipalsGrid')}
                    width={50}
                    allowSorting={false}
                    allowResizing={false}
                    type='actions'
                    fixed={true}
                    fixedPosition={'right'}
                />
            </BfiDataGrid>
            <BorrowerModals />
        </>
    );
};

export default PrincipalUsersTable;
